/* Krishna Furniture 3D — theme behaviour (no dependencies). */
(function () {
  'use strict';

  var KF = window.KF || {};
  window.KF = KF;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 1024px)').matches; };

  function lowPower() {
    var c = navigator.connection || {};
    if (c.saveData) return true;
    if (c.effectiveType && /(^|-)2g$/.test(c.effectiveType)) return true;
    if (navigator.deviceMemory !== undefined && navigator.deviceMemory < 3) return true;
    if (navigator.hardwareConcurrency !== undefined && navigator.hardwareConcurrency < 4) return true;
    return false;
  }
  KF.lowPower = lowPower;

  /* ------------------------------------------------------------------ */
  /* Tracking: GA4 / Google Ads / Meta Pixel (whichever is installed)    */
  /* plus Shopify Customer Events for custom pixels.                     */
  /* ------------------------------------------------------------------ */
  function track(event, params, meta) {
    params = params || {};
    try { if (window.gtag) window.gtag('event', event, params); } catch (e) {}
    try {
      if (window.fbq && meta) window.fbq(meta.custom ? 'trackCustom' : 'track', meta.name, meta.params || params);
    } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('kf_' + event, params); } catch (e) {}
  }
  KF.track = {
    leadFormOpen: function (source) { track('lead_form_open', { source: source }, { name: 'LeadFormOpen', custom: true }); },
    leadFormSubmit: function (p) {
      track('generate_lead', Object.assign({ currency: 'INR' }, p), { name: 'Lead', params: { content_category: p.furniture, content_name: p.source } });
      if (KF.adsConversion && window.gtag) window.gtag('event', 'conversion', { send_to: KF.adsConversion });
    },
    quoteClick: function (source) { track('quote_click', { source: source }, { name: 'QuoteClick', custom: true }); },
    whatsAppClick: function (source) { track('whatsapp_click', { source: source }, { name: 'Contact', params: { method: 'whatsapp', source: source } }); },
    productInteraction: function (action, product, detail) { track('product_interaction', { action: action, product: product, detail: detail }, { name: 'ViewContent', params: { content_name: product, content_type: action } }); },
    threeD: function (action, model) { track('3d_interaction', { action: action, model: model }, { name: 'ThreeDInteraction', custom: true }); },
    consultationClick: function (source) { track('consultation_click', { source: source }, { name: 'Schedule', params: { source: source } }); }
  };

  document.addEventListener('click', function (e) {
    var wa = e.target.closest('[data-kf-whatsapp]');
    if (wa) KF.track.whatsAppClick(wa.getAttribute('data-kf-whatsapp'));
    var t = e.target.closest('[data-kf-track]');
    if (t) KF.track.productInteraction(t.getAttribute('data-kf-track'), t.getAttribute('data-kf-track-label') || '');
  });

  /* ------------------------------------------------------------------ */
  /* Header: solid on scroll, active section, mobile menu                */
  /* ------------------------------------------------------------------ */
  var header = document.querySelector('[data-kf-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-solid', window.scrollY > 24 || header.classList.contains('menu-open')); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = header.querySelector('[data-kf-menu-toggle]');
    var menu = header.querySelector('[data-kf-mobile-menu]');
    var setMenu = function (open) {
      if (!toggle || !menu) return;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      header.classList.toggle('menu-open', open);
      document.body.classList.toggle('kf-lock', open);
      onScroll();
    };
    if (toggle) toggle.addEventListener('click', function () { setMenu(toggle.getAttribute('aria-expanded') !== 'true'); });
    if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a, [data-kf-quote]')) setMenu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && header.classList.contains('menu-open')) setMenu(false); });

    // Highlight in-page anchor links for the section in view (home page).
    var links = Array.prototype.slice.call(header.querySelectorAll('[data-kf-nav-link]')).filter(function (a) {
      return a.hash && a.pathname === window.location.pathname && document.querySelector(a.hash);
    });
    if (links.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (a) {
            var on = a.hash === '#' + entry.target.id;
            a.classList.toggle('is-active', on);
            if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      links.forEach(function (a) { io.observe(document.querySelector(a.hash)); });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Reveal on scroll                                                    */
  /* ------------------------------------------------------------------ */
  var reveals = document.querySelectorAll('.kf-reveal');
  if (!('IntersectionObserver' in window) || reduceMotion) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); rio.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(function (el) { rio.observe(el); });
  }

  /* ------------------------------------------------------------------ */
  /* Modals (focus trap, Escape, restore focus)                          */
  /* ------------------------------------------------------------------ */
  var openModalEl = null;
  var lastFocus = null;
  var focusables = function (root) {
    return Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  };
  function openModal(modal) {
    if (!modal) return;
    if (openModalEl && openModalEl !== modal) closeModal(true);
    lastFocus = document.activeElement;
    modal.hidden = false;
    openModalEl = modal;
    document.body.classList.add('kf-lock');
    setTimeout(function () {
      var els = focusables(modal);
      (els[1] || els[0] || modal).focus();
    }, 60);
    modal.dispatchEvent(new CustomEvent('kf:open'));
  }
  function closeModal(keepFocus) {
    if (!openModalEl) return;
    var m = openModalEl;
    m.hidden = true;
    openModalEl = null;
    document.body.classList.remove('kf-lock');
    m.dispatchEvent(new CustomEvent('kf:close'));
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  KF.openModal = openModal;
  KF.closeModal = closeModal;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kf-modal-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (!openModalEl) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    var els = focusables(openModalEl);
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Quote modal: any [data-kf-quote] opens it with its own source/title/preset. */
  var quoteModal = document.getElementById('KfQuoteModal');
  var quoteForm = quoteModal && quoteModal.querySelector('form');
  var defaultQuoteTitle = quoteForm && quoteForm.querySelector('[data-kf-form-title]') ? quoteForm.querySelector('[data-kf-form-title]').textContent : '';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-kf-quote]');
    if (!trigger || !quoteModal || !quoteForm) return;
    e.preventDefault();
    var source = trigger.getAttribute('data-kf-quote') || 'cta';
    var title = trigger.getAttribute('data-kf-quote-title') || defaultQuoteTitle;
    var furniture = trigger.getAttribute('data-kf-quote-furniture') || '';
    if (trigger.hasAttribute('data-kf-consult')) KF.track.consultationClick(source);
    KF.track.quoteClick(source);
    KF.track.leadFormOpen(source);

    resetLeadForm(quoteForm);
    quoteForm.querySelector('[data-kf-source]').value = source;
    var h = quoteForm.querySelector('[data-kf-form-title]');
    if (h) h.textContent = title;
    var panel = quoteModal.querySelector('[data-kf-modal-label]');
    if (panel) panel.setAttribute('aria-label', title);
    var sel = quoteForm.querySelector('[data-kf-furniture]');
    if (sel) {
      sel.value = '';
      if (furniture) Array.prototype.forEach.call(sel.options, function (o) { if (o.value === furniture) sel.value = furniture; });
    }
    openModal(quoteModal);
  });

  /* Tour modal */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-kf-tour]')) return;
    var tour = document.getElementById('KfTourModal');
    if (!tour) return;
    KF.track.threeD('tour_open', 'tour');
    openModal(tour);
  });

  /* ------------------------------------------------------------------ */
  /* Lead forms                                                          */
  /* ------------------------------------------------------------------ */
  function normalizeIndianPhone(raw) {
    var d = String(raw).replace(/[\s\-().]/g, '');
    if (d.indexOf('+91') === 0) d = d.slice(3);
    else if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    else if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return /^[6-9]\d{9}$/.test(d) ? '+91' + d : null;
  }

  var messages = {
    name: 'Please enter your name.',
    phone: 'Enter a valid 10-digit Indian mobile number.',
    phoneEmpty: 'Please enter your phone number.',
    city: 'Please enter your city.',
    furniture: 'Please choose the furniture you need.',
    budget: 'Please choose a budget range.'
  };

  function setError(input, msg) {
    var err = document.getElementById(input.id + '-error');
    if (msg) {
      input.setAttribute('aria-invalid', 'true');
      if (err) { err.textContent = msg; err.hidden = false; input.setAttribute('aria-describedby', err.id); }
    } else {
      input.removeAttribute('aria-invalid');
      if (err) { err.hidden = true; err.textContent = ''; }
      input.removeAttribute('aria-describedby');
    }
  }

  function validate(form) {
    var firstBad = null;
    form.querySelectorAll('[data-kf-validate]').forEach(function (input) {
      var v = input.value.trim();
      var kind = input.getAttribute('data-kf-validate');
      var msg = '';
      if (kind === 'name' && v.length < 2) msg = messages.name;
      if (kind === 'phone') msg = !v ? messages.phoneEmpty : (normalizeIndianPhone(v) ? '' : messages.phone);
      if (kind === 'city' && !v) msg = messages.city;
      if (kind === 'furniture' && !v) msg = messages.furniture;
      if (kind === 'budget' && !v) msg = messages.budget;
      setError(input, msg);
      if (msg && !firstBad) firstBad = input;
    });
    if (firstBad) firstBad.focus();
    return !firstBad;
  }

  function utmString() {
    var p = new URLSearchParams(window.location.search);
    return ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid']
      .filter(function (k) { return p.has(k); })
      .map(function (k) { return k + '=' + p.get(k); })
      .join('; ');
  }
  // Remember ad parameters for the session so they survive in-site navigation.
  try {
    var utmNow = utmString();
    if (utmNow) sessionStorage.setItem('kf_utm', utmNow);
  } catch (e) {}
  function storedUtm() {
    try { return utmString() || sessionStorage.getItem('kf_utm') || ''; } catch (e) { return utmString(); }
  }

  function resetLeadForm(form) {
    var fields = form.querySelector('[data-kf-fields]');
    var success = form.querySelector('[data-kf-success]');
    if (fields) fields.hidden = false;
    if (success) success.hidden = true;
    var err = form.querySelector('[data-kf-form-error]');
    if (err) err.hidden = true;
    form.querySelectorAll('[data-kf-validate]').forEach(function (i) { setError(i, ''); });
  }

  function value(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function waLink(text) {
    if (!KF.whatsappNumber) return null;
    return 'https://wa.me/' + KF.whatsappNumber + '?text=' + encodeURIComponent(text || KF.whatsappMessage || '');
  }

  function sendWebhook(lead) {
    if (!KF.webhookUrl) return;
    try {
      // text/plain avoids a CORS preflight, so simple endpoints such as Google Apps Script accept it.
      fetch(KF.webhookUrl, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(lead) });
    } catch (e) {}
  }

  function showSuccess(form, lead) {
    var fields = form.querySelector('[data-kf-fields]');
    var success = form.querySelector('[data-kf-success]');
    if (fields) fields.hidden = true;
    if (!success) return;
    success.hidden = false;
    var title = success.querySelector('.kf-lead-form__success-title');
    var first = lead && lead.name ? lead.name.split(' ')[0] : '';
    if (title && first && title.textContent.indexOf(first) === -1) title.textContent = title.textContent.replace(/!?\s*$/, ', ' + first + '!');
    var msg = lead ? ['Hi, I would like a quote.', 'Name: ' + lead.name, 'City: ' + lead.city, 'Furniture: ' + lead.furniture, lead.budget ? 'Budget: ' + lead.budget : ''].filter(Boolean).join('\n') : '';
    var link = waLink(msg);
    var waBtn = form.querySelector('[data-kf-wa-dynamic]');
    if (waBtn && link) { waBtn.href = link; waBtn.hidden = false; }
    return link;
  }

  document.querySelectorAll('form.kf-lead-form').forEach(function (form) {
    ['input', 'change'].forEach(function (type) {
      form.addEventListener(type, function (e) {
        if (e.target.getAttribute && e.target.getAttribute('aria-invalid') === 'true') setError(e.target, '');
      });
    });
  });

  /*
   * Submit flow:
   *  1. Validate (window/capture, so an invalid form is stopped before Shopify's captcha handler sees it).
   *  2. If the form has data-kf-endpoint (FormSubmit AJAX), send the lead there and show success in place.
   *  3. If that fails (network, not yet activated, service limits), submit the Shopify contact form natively
   *     instead. Shopify's hCaptcha script intercepts that native submit, adds its token and posts the form
   *     (posting it via fetch skips the token and Shopify answers 403), so the lead still reaches the store email.
   */
  function collectLead(form) {
    var phoneInput = form.querySelector('[data-kf-validate="phone"]');
    var normalized = normalizeIndianPhone(phoneInput.value) || phoneInput.value;
    phoneInput.value = normalized;
    form.querySelector('[data-kf-page]').value = window.location.href.split('#')[0].split('?')[0];
    form.querySelector('[data-kf-utm]').value = storedUtm();
    return {
      name: value(form, 'contact[name]'),
      phone: normalized,
      city: value(form, 'contact[City]'),
      furniture: value(form, 'contact[Furniture]'),
      budget: value(form, 'contact[Budget]'),
      source: value(form, 'contact[Lead source]'),
      page: value(form, 'contact[Page]'),
      adTracking: value(form, 'contact[Ad tracking]'),
      submittedAt: new Date().toISOString()
    };
  }

  function sendToEndpoint(form, lead) {
    var payload1 = {

        name:
        lead.name,

        mobile:
        lead.phone,

        location:
        lead.city ,

        message:
        `lead furniture: ${lead.furniture}, Budget Range: ${lead.budget||'—'}`,
sourceId:193
      };
fetch('https://whatsappapi.growaasan.com/api/v1/websiteIntegrationWithGrowAasan', {
    method: 'POST',
    headers: {
        'clientid': '100063',
        'authkey': 'dTRWOW5yRjl2N203Nk4rU3ZwWTJoZz09',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(
     payload1   
    )
})
.then(response => response.json())
.then(data => {
    console.log('Response:', data);
})
.catch(error => {
    console.error('Error:', error);
});

    var payload = {
      Name: lead.name,
      Phone: lead.phone,
      City: lead.city,
      Furniture: lead.furniture,
      Budget: lead.budget || '—',
      'Lead source': lead.source,
      Page: lead.page,
      'Ad tracking': lead.adTracking || '—',
      'Submitted at': new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
      _subject: (form.getAttribute('data-kf-subject') || 'New enquiry') + ' — ' + lead.name + ' (' + lead.city + ')',
      _template: 'table',
      _captcha: 'false'
    };
    var cc = (form.getAttribute('data-kf-cc') || '').trim();
    if (cc) payload._cc = cc;
    return fetch(form.getAttribute('data-kf-endpoint'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok || String(r.data.success) !== 'true') throw new Error((r.data && r.data.message) || 'Lead service error');
      });
  }

  function finishSuccess(form, lead) {
    var link = showSuccess(form, lead);
    KF.track.leadFormSubmit({ source: lead.source, furniture: lead.furniture, city: lead.city, budget: lead.budget || undefined });
    if (KF.openWhatsAppAfterSubmit && link) { KF.track.whatsAppClick(lead.source + '-auto'); window.open(link, '_blank', 'noopener'); }
    try { form.reset(); } catch (e) {}
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('kf-lead-form')) return;
    if (!validate(form)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    var lead = collectLead(form);
    var btn = form.querySelector('[data-kf-submit]');
    var errBox = form.querySelector('[data-kf-form-error]');
    if (errBox) errBox.hidden = true;
    if (!form.dataset.kfWebhookSent) { sendWebhook(lead); form.dataset.kfWebhookSent = '1'; }

    var endpoint = form.getAttribute('data-kf-endpoint');
    var honey = form.querySelector('[data-kf-honey]');
    if (endpoint && form.dataset.kfNative !== 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (honey && honey.value) { showSuccess(form, lead); return; } // bot filled the hidden field
      btn.disabled = true;
      btn.classList.add('is-loading');
      sendToEndpoint(form, lead)
        .then(function () { finishSuccess(form, lead); })
        .catch(function (err) {
          if (window.console) console.warn('[kf] lead service failed, using Shopify contact form instead:', err && err.message);
          form.dataset.kfNative = 'true';
          btn.disabled = false;
          try { sessionStorage.setItem('kf_pending_lead', JSON.stringify({ formId: form.id, lead: lead })); } catch (x) {}
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        })
        .then(function () { btn.disabled = false; if (form.dataset.kfNative !== 'true') btn.classList.remove('is-loading'); });
      return;
    }

    // Native Shopify submit (no endpoint configured, or fallback): Shopify's captcha takes over from here.
    try { sessionStorage.setItem('kf_pending_lead', JSON.stringify({ formId: form.id, lead: lead })); } catch (err) {}
    btn.classList.add('is-loading');
    // If the visitor closes the captcha without finishing, give the button back.
    setTimeout(function () { btn.classList.remove('is-loading'); delete form.dataset.kfWebhookSent; delete form.dataset.kfNative; }, 20000);
  }, true);

  /* Back from Shopify after a submit: ?contact_posted=true#<form id> (or the form re-rendered with errors). */
  (function () {
    var params = window.location.search;
    var pending = null;
    try { pending = JSON.parse(sessionStorage.getItem('kf_pending_lead') || 'null'); } catch (e) {}
    var targetId = (window.location.hash || '').slice(1) || (pending && pending.formId) || '';
    var target = targetId && document.getElementById(targetId);

    if (/[?&]contact_posted=true/.test(params)) {
      // Shopify marks every contact form as posted; show the success state only in the one that was used.
      document.querySelectorAll('form.kf-lead-form').forEach(function (f) { if (target && f !== target) resetLeadForm(f); });
      var form = target || document.querySelector('form.kf-lead-form');
      var lead = pending && pending.lead;
      var link = form ? showSuccess(form, lead) : null;
      try {
        if (!sessionStorage.getItem('kf_lead_tracked_' + params)) {
          KF.track.leadFormSubmit({ source: (lead && lead.source) || 'form', furniture: (lead && lead.furniture) || '', city: (lead && lead.city) || '', budget: (lead && lead.budget) || undefined });
          sessionStorage.setItem('kf_lead_tracked_' + params, '1');
          if (KF.openWhatsAppAfterSubmit && link) { KF.track.whatsAppClick(((lead && lead.source) || 'form') + '-auto'); window.open(link, '_blank', 'noopener'); }
        }
        sessionStorage.removeItem('kf_pending_lead');
      } catch (e) {}
      if (form) {
        var modal = form.closest('[data-kf-modal]');
        if (modal) openModal(modal);
        else form.scrollIntoView({ block: 'center' });
      }
      // Drop the flag from the address bar so a refresh doesn't look like a new submission.
      try { window.history.replaceState({}, '', window.location.pathname); } catch (e) {}
      return;
    }

    // Shopify re-rendered the page with an error on one form (e.g. captcha failed): bring that form into view.
    var errored = document.querySelector('form.kf-lead-form .kf-form-alert[role="alert"]:not([data-kf-form-error])');
    if (errored) {
      var f = errored.closest('form');
      var m = f.closest('[data-kf-modal]');
      if (m) openModal(m); else f.scrollIntoView({ block: 'center' });
    }
  })();

  /* ------------------------------------------------------------------ */
  /* Videos: ambient (desktop only, after load) and showcase (in view)   */
  /* ------------------------------------------------------------------ */
  function loadVideo(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    v.src = v.dataset.src;
    v.addEventListener('canplay', function () { v.classList.add('is-ready'); }, { once: true });
    v.addEventListener('error', function () { v.remove(); }, { once: true });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function initAmbientVideos() {
    if (reduceMotion || lowPower() || !isDesktop()) return;
    var vids = document.querySelectorAll('video[data-kf-ambient-video]');
    if (!vids.length) return;
    var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) { loadVideo(v); v.play().catch(function () {}); }
        else if (v.dataset.loaded) v.pause();
      });
    }, { rootMargin: '200px 0px' }) : null;
    vids.forEach(function (v) { vio ? vio.observe(v) : loadVideo(v); });
  }
  if (document.readyState === 'complete') setTimeout(initAmbientVideos, 1200);
  else window.addEventListener('load', function () { setTimeout(initAmbientVideos, 1200); });

  document.querySelectorAll('[data-kf-showcase]').forEach(function (box) {
    var v = box.querySelector('[data-kf-showcase-video]');
    var btn = box.querySelector('[data-kf-showcase-toggle]');
    var paused = reduceMotion;
    var inView = false;
    var sync = function () {
      box.classList.toggle('is-paused', paused);
      if (btn) btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      if (inView && !paused) { loadVideo(v); v.play().catch(function () { paused = true; box.classList.add('is-paused'); }); }
      else if (v.dataset.loaded) v.pause();
    };
    if (btn) btn.addEventListener('click', function () { paused = !paused; if (!paused) inView = true; sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; sync(); }, { rootMargin: '200px 0px' }).observe(box);
    }
    sync();
  });

  /* ------------------------------------------------------------------ */
  /* Parallax (subtle, desktop + tablet)                                 */
  /* ------------------------------------------------------------------ */
  var layers = document.querySelectorAll('[data-kf-parallax]');
  if (layers.length && !reduceMotion) {
    var ticking = false;
    var update = function () {
      ticking = false;
      layers.forEach(function (wrap) {
        var inner = wrap.querySelector('[data-kf-parallax-layer]');
        var r = wrap.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var progress = (r.top + r.height / 2 - window.innerHeight / 2) / (window.innerHeight / 2 + r.height / 2);
        inner.style.transform = 'translate3d(0,' + (progress * -40).toFixed(1) + 'px,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------ */
  /* Before / after slider                                               */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-kf-compare]').forEach(function (frame) {
    var handle = frame.querySelector('[data-kf-compare-handle]');
    var dragging = false, tracked = false;
    var set = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      frame.style.setProperty('--kf-pos', pct + '%');
      handle.setAttribute('aria-valuenow', Math.round(pct));
      handle.setAttribute('aria-valuetext', Math.round(pct) + '% before');
    };
    var fromX = function (x) {
      var r = frame.getBoundingClientRect();
      set(((x - r.left) / r.width) * 100);
      if (!tracked) { tracked = true; KF.track.productInteraction('before_after_drag', 'transformation'); }
    };
    frame.addEventListener('pointerdown', function (e) { dragging = true; frame.setPointerCapture(e.pointerId); fromX(e.clientX); });
    frame.addEventListener('pointermove', function (e) { if (dragging) fromX(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (t) { frame.addEventListener(t, function () { dragging = false; }); });
    handle.addEventListener('keydown', function (e) {
      var now = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      var step = e.shiftKey ? 10 : 4;
      if (e.key === 'ArrowLeft') set(now - step);
      else if (e.key === 'ArrowRight') set(now + step);
      else if (e.key === 'Home') set(0);
      else if (e.key === 'End') set(100);
      else return;
      e.preventDefault();
    });
  });

  /* ------------------------------------------------------------------ */
  /* 3D product section: thumbnails + finishes (viewer lives in kf-3d.js) */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-kf-product3d]').forEach(function (sec) {
    var viewerEl = sec.querySelector('[data-kf-viewer]');
    var photos = sec.querySelectorAll('[data-kf-photo]');
    var thumbs = sec.querySelectorAll('[data-kf-view]');
    var label = sec.querySelector('[data-kf-finish-label]');
    var hint = sec.querySelector('[data-kf-finish-hint]');
    var name = viewerEl ? viewerEl.getAttribute('data-label') : '';

    var show = function (id) {
      thumbs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-kf-view') === id)); });
      photos.forEach(function (p) { p.hidden = p.getAttribute('data-kf-photo') !== id; });
      if (viewerEl) viewerEl.dispatchEvent(new CustomEvent('kf:active', { detail: id === '3d' }));
    };
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(t.getAttribute('data-kf-view'));
        KF.track.productInteraction('view_select', name, t.getAttribute('data-kf-view'));
      });
    });

    sec.querySelectorAll('[data-kf-finish]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        sec.querySelectorAll('[data-kf-finish]').forEach(function (o) { o.setAttribute('aria-checked', String(o === sw)); });
        if (label) label.textContent = sw.getAttribute('data-label');
        if (viewerEl) {
          viewerEl.dispatchEvent(new CustomEvent('kf:finish', { detail: { color: sw.getAttribute('data-color'), stitch: sw.getAttribute('data-stitch') } }));
          if (viewerEl.classList.contains('is-3d')) show('3d');
        }
        KF.track.productInteraction('finish_select', name, sw.getAttribute('data-label'));
      });
    });

    // When 3D isn't available, hide the 3D tile, show the first photo and adjust the hint.
    if (viewerEl) viewerEl.addEventListener('kf:no3d', function () {
      var tile = sec.querySelector('[data-kf-thumb-3d]');
      if (tile) tile.hidden = true;
      if (photos.length) show('0');
      if (hint) hint.textContent = 'Available in ' + sec.querySelectorAll('[data-kf-finish]').length + ' finishes.';
    });
  });

  /* ------------------------------------------------------------------ */
  /* Mobile sticky bar: appears after the hero                           */
  /* ------------------------------------------------------------------ */
  var bar = document.querySelector('[data-kf-mobile-bar]');
  if (bar) {
    var barCheck = function () {
      var show = window.scrollY > window.innerHeight * 0.6;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
    };
    barCheck();
    window.addEventListener('scroll', barCheck, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* Product page gallery + quantity                                     */
  /* ------------------------------------------------------------------ */
  document.querySelectorAll('[data-kf-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-kf-slide]');
    g.querySelectorAll('[data-kf-slide-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-kf-slide-btn');
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-kf-slide') !== id; });
        g.querySelectorAll('[data-kf-slide-btn]').forEach(function (o) { o.setAttribute('aria-current', String(o === b)); });
      });
    });
  });
  document.querySelectorAll('[data-kf-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(parseInt(input.min || '1', 10), n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
  document.querySelectorAll('[data-kf-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var data = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    var idInput = form.querySelector('input[name="id"]');
    var price = document.querySelector('[data-kf-price]');
    var submit = form.querySelector('[type="submit"]');
    picker.addEventListener('change', function () {
      var chosen = Array.prototype.map.call(picker.querySelectorAll('select'), function (s) { return s.value; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) return;
      idInput.value = v.id;
      if (price) price.innerHTML = v.price_html;
      if (submit) { submit.disabled = !v.available; submit.querySelector('span').textContent = v.available ? data.add_label : data.sold_out_label; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    });
  });

  /* Collection sort */
  document.querySelectorAll('[data-kf-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });
})();
